import { render, staticRenderFns } from "./TableFrame.vue?vue&type=template&id=0e946f60&"
import script from "./TableFrame.vue?vue&type=script&lang=js&"
export * from "./TableFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports